exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div h3 {\n  margin-bottom: 0px;\n  text-align: left;\n  line-height: 100%; }\n\ndiv iframe {\n  width: 850px;\n  height: 477px; }\n\n@media (max-width: 911px) {\n  div h3 {\n    padding-left: 5px; }\n  div .vimeo-iframe-wrapper {\n    position: relative;\n    padding-bottom: 56%;\n    height: 0;\n    overflow: hidden; }\n    div .vimeo-iframe-wrapper iframe {\n      width: 100%;\n      height: 100%;\n      position: absolute;\n      top: 0;\n      left: 0; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/mdg/Source/markclimb/src/app/vimeo/vimeo-player.component.scss
// module id = ../../../../../src/app/vimeo/vimeo-player.component.scss
// module chunks = main